import React, { useState } from 'react';
import './Login.css';
import logo from '../assets/Logo_SALVIR.png';
import { loginMedico, fetchCsrfToken } from "../services/auth";
import { useNavigate } from "react-router-dom";
import api, { API_AUTH_URL } from "../services/config";
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import axios from 'axios';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const handleLogin = async (event) => {
    event.preventDefault();
     if (isLoggingIn) return;

    setIsLoggingIn(true);
    setErrorMessage('');
    try {
      await fetchCsrfToken();
      await loginMedico(email, password);
      await new Promise((r) => setTimeout(r, 100));
      await fetchCsrfToken();

      await api.get("medicos/me/");
      localStorage.setItem("user_email", email);

      toast.success("Inicio de sesión exitoso", {
        autoClose: 1500,
      });
      
      // 🟦 Si venimos de una sesión expirada, regresar EXACTO a donde estábamos
      const redirectUrl = localStorage.getItem("salvir_redirect_after_login");
      if (redirectUrl) {
        localStorage.removeItem("salvir_redirect_after_login");
        window.location.href = redirectUrl;
        return; // Detener aquí, no sigas al dashboard normal
      }
      navigate("/dashboard/inicio");

    } catch (loginError) {
      console.error("Error en login:", loginError);

      const data = loginError.response?.data;
     
      const getFirst = (value) => {
        if (Array.isArray(value)) return value[0];
        return value;
      };

      const backendError = getFirst(data?.error);
      const backendMessage = getFirst(data?.message);
      const nonFieldError = getFirst(data?.non_field_errors);
      const detail = getFirst(data?.detail);
      const emailError = getFirst(data?.email);
      const passwordError = getFirst(data?.password);

      if (backendError === "account_disabled") {
        const msg = backendMessage || "Tu cuenta está temporalmente suspendida. Contacta a soporte.";
        toast.error(msg);
        setErrorMessage("Tu cuenta está temporalmente suspendida. Contacta a soporte.");

      } else if (backendError === "email_not_verified") {
        toast.error(backendMessage || "Tu correo no está verificado.");
        setErrorMessage("¿No te llegó el correo? Haz click aquí para reenviarlo.");

      } else if (nonFieldError === "E-mail is not verified.") {
        toast.error("Tu correo no está verificado. Por favor revisa tu bandeja de entrada.");
        setErrorMessage("¿No te llegó el correo? Haz click aquí para reenviarlo.");

      } else if (nonFieldError === "Unable to log in with provided credentials.") {
        toast.error("Correo o contraseña incorrectos.");
        setErrorMessage("Correo o contraseña incorrectos.");

      } else if (nonFieldError) {
        toast.error(nonFieldError);
        setErrorMessage(nonFieldError);

      } else if (detail) {
        toast.error(detail);
        setErrorMessage(detail);

      } else if (emailError) {
        const msg = "Ingresa un correo electrónico válido.";
        toast.error(msg);
        setErrorMessage(msg);

      } else if (passwordError) {
        toast.error(passwordError);
        setErrorMessage(passwordError);
      } else {
        toast.error("No fue posible conectar con el servidor. Por favor contacte a soporte.");
        setErrorMessage("No fue posible conectar con el servidor. Por favor contacte a soporte.");
      }
       } finally {
      setIsLoggingIn(false);
    }
  };

  const handleResendEmail = async () => {
    try {
      await axios.post(`${API_AUTH_URL}registration/resend-email/`, {
        email: email,
      }, { withCredentials: true });

      toast.success("Correo de verificación reenviado.");
    } catch (error) {
      console.error("Error al reenviar correo:", error);
      const data = error.response?.data;
      if (data?.detail) {
        toast.error(data.detail);
      } else {
        toast.error("Error al reenviar el correo.");
      }
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="auth-container">
      <img src={logo} alt="Logo" className="logo" />
      <h2>Iniciar Sesión</h2>
      <form onSubmit={handleLogin}>
        <div className="form-group">
          <label htmlFor="email">Correo Electrónico</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={isLoggingIn}
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Contraseña</label>
          <div className="password-container">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={isLoggingIn}
            />
            <button type="button" onClick={togglePasswordVisibility} className="password-toggle">
              {showPassword ? "Ocultar" : "Mostrar"}
            </button>
          </div>
        </div>

        {errorMessage && (
          <div className="error-message">
            <p>{errorMessage}</p>
            {errorMessage.includes("reenviarlo") && (
              <button onClick={handleResendEmail} className="auth-button">
                Reenviar Correo de Verificación
              </button>
            )}
          </div>
        )}

        <button type="submit" className="auth-button" disabled={isLoggingIn}>
  {isLoggingIn ? "Ingresando..." : "Iniciar Sesión"}
</button>
      </form>

      <div className="forgot-password">
        <p>¿Olvidaste tu contraseña?</p>
         <button className="auth-button" type="submit" onClick={() => navigate("/recuperar-password")} disabled={isLoggingIn}>
          Recuperar Contraseña
        </button>
      </div>

      <div className="register-prompt">
        <p>¿Aún no tienes cuenta?</p>
        <Link to="/registro">
          <button className="auth-button" type="submit" disabled={isLoggingIn}>
            Regístrate
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Login;
